<template>
  <van-popup
    v-model="kaiguan"
    get-container="body"
    :style="{background:'transparent'}"
    :close-on-click-overlay="false"
  >
    <div class="alert">
      <div class="title">
        <button class="cancle" @click.stop="$emit('cancle-alert')"></button>
        <slot name="title"></slot>
      </div>
      <div class="content">
        <slot name="content"></slot>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: "Alert",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    kaiguan: {
      get: function() {
        return this.show;
      },
      set: function() {
        return;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.title {
  margin: 0 auto 30px;
  width: 700px;
  height: 70px;
  border-radius: 35px;
  background: linear-gradient(0deg, #dc580d, #e28215);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 40px;
  color: #ffffff;
  position: relative;
  &::before {
    content: "";
    width: 20px;
    height: 30px;
    background: linear-gradient(
      90deg,
      rgba(241, 195, 151, 1),
      rgba(255, 221, 179, 1)
    );
    position: absolute;
    left: 80px;
    bottom: -30px;
  }
  &::after {
    content: "";
    width: 20px;
    height: 30px;
    background: linear-gradient(
      90deg,
      rgba(241, 195, 151, 1),
      rgba(255, 221, 179, 1)
    );
    position: absolute;
    right: 80px;
    bottom: -30px;
  }
  .cancle {
    cursor: pointer;
    position: absolute;
    right: -120px;
    top: 50%;
    transform: translateY(-50%);
    width: 35px;
    height: 35px;
    display: block;
    background-image: url("../assets/guanbi-min.png");
    background-size: 100% 100%;
  }
}
.content {
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  border: 0.1rem solid rgba(255, 255, 255, 1);
  box-shadow: inset 0px 3px 21px 0px rgba(244, 160, 68, 0.78);
  border-radius: 30px;
}
</style>